import { Component, Input } from '@angular/core'

@Component({
  selector: 'lin-dashboard-card-item',
  templateUrl: './dashboard-card-item.component.html',
  styleUrls: ['./dashboard-card-item.component.scss'],
  standalone: false,
})
export class DashboardCardItemComponent {
  @Input() title: string
  @Input() icon: 'driver' | 'vehicle' | 'document' = 'driver'

  get itemIcon(): string {
    const iconToMaterialIconMap = {
      driver: 'account_circle',
      vehicle: 'directions_car',
      document: 'insert_drive_file',
    }
    return iconToMaterialIconMap[this.icon]
  }
}
